module.exports = __webpack_public_path__ + "img/gomall-banner.bec8e99b.png";